import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import store from "./redux/store";
import AppRouter from "./routes/appRouter";
import theme from "./styles/theme";
import ScrollToTop from "./utils/scrollToTop";
import * as Sentry from "@sentry/react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, refetchOnMount: false },
  },
});

const App = () => {
  return (
    <Sentry.ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <Suspense fallback={<></>}>
              <BrowserRouter>
                <ScrollToTop />
                <AppRouter />
              </BrowserRouter>
            </Suspense>
          </Provider>
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
